// добавить еще такие белые точки - , Нью-Дели (Индия)

const capitals = [
  {
    lat: 25.015137,
    lng: 22.97953,
    country: 'Turkey',
  },
  {
    lat: -15.121435,
    lng: 95.774124,
    country: 'Indonesia',
  },
  {
    lat: 24.5326,
    lng: 117.024612,
    country: 'South Korea',
  },
  {
    lat: 5.033333,
    lng: -25.233334,
    country: 'Dakar',
  },
  {
    lat: -30.90278,
    lng: -53.2075,
    country: 'Brazilia',
  },
  {
    lat: 22.73061,
    lng: -87.935242,
    country: 'USA, Washington',
  },
  {
    lat: 35.424721,
    lng: -85.695,
    country: 'Canada',
  },
  {
    lat: 25.424721,
    lng: -132.695,
    country: 'San Francisco',
  },
  {
    lat: 0.736717,
    lng: 90.523186,
    country: 'Tailand',
  },
  {
    lat: 13.286106,
    lng: 40.534817,
    country: 'Qatar',
  },
  {
    lat: 17.286106,
    lng: 36.534817,
    country: 'Kuwait',
  },
  {
    lat: -9.29027,
    lng: 92.693207,
    country: 'Singapore',
  },
  {
    lat: 57.424721,
    lng: -165.695,
    country: 'USA, Alaska',
  },

  {
    lat: 2.599512,
    lng: 111.984222,
    country: 'Philippines',
  },
  {
    lat: 10.774265,
    lng: 35.738586,
    country: 'Saudi Arabia',
  },
  {
    lat: 24.466667,
    lng: 54.366669,
    country: 'UAE',
  },

  {
    lat: 13.801323,
    lng: 67.917503,
    country: 'India',
  },

  {
    lat: 9.451054,
    lng: -108.125519,
    country: 'Mexico',
  },
  {
    lat: -44.603722,
    lng: -71.381592,
    country: 'Argentina',
  },

  {
    lat: -44.603722,
    lng: -83.381592,
    country: 'Chile',
  },

  {
    lat: -13.046374,
    lng: -91.042793,
    country: 'Peru',
  },
  {
    lat: 22.737232,
    lng: -10.086472,
    country: 'Algiers',
  },
  {
    lat: 17.033333,
    lng: 20.233334,
    country: 'Egypt',
  },
  {
    lat: -16.161184,
    lng: 25.745426,
    country: 'Tanzania',
  },
  {
    lat: 51.192059,
    lng: 13.945831,
    country: 'Finland',
  },
  {
    lat: 48.911491,
    lng: 0.757933,
    country: 'Norway',
  },
  {
    lat: 49.334591,
    lng: 6.06324,
    country: 'Sweden',
  },
  {
    lat: 41.35014,
    lng: -16.266155,
    country: 'Ireland',
  },
  {
    lat: -30.7166638,
    lng: 18.2333324,
    country: 'South Africa',
  },
  {
    lat: 23.652832,
    lng: 130.839478,
    country: 'Japan',
  },
  {
    lat: 12.105497,
    lng: 111.597366,
    country: 'Taiwan',
  },
  {
    lat: 10.302711,
    lng: 105.177216,
    country: 'Hong Kong',
  },
  {
    lat: -42.848461,
    lng: 163.763336,
    country: 'New Zealand',
  },
  {
    lat: -6.140853,
    lng: 90.693207,
    country: 'Malaysia',
  },

  {
    lat: 38.450001,
    lng: 20.523333,
    country: 'Ukraine',
  },
  {
    lat: 40.237049,
    lng: 17.017532,
    country: 'Poland',
  },
  {
    lat: 33.00367,
    lng: 16.907089,
    country: 'Moldova',
  },
  {
    lat: 32.439663,
    lng: 14.096306,
    country: 'Romania',
  },
  {
    lat: 24.73061,
    lng: -85.935242,
    country: 'USA',
  },
  {
    lat: 25.90181559201167,
    lng: 4.493133746956499,
    country: 'Italy',
  },
  {
    lat: 25.416775,
    lng: -13.70379,
    country: 'Spain',
  },
  {
    lat: 46,
    lng: 14.753574,
    country: 'Latvia',
  },

  {
    lat: 33.497913,
    lng: 10.040236,
    country: 'Hungary',
  },

  {
    lat: 36.509865,
    lng: -12.118092,
    country: 'United Kingdom',
  },
  {
    lat: 30.916668,
    lng: 116.383331,
    country: 'China',
  },
  // {
  //   lat: 32.864716,
  //   lng: -6.349014,
  //   country: 'France',
  // },
  {
    lat: -27.8643943,
    lng: 120.2153101,
    country: 'Australia',
  },
  {
    lat: 35.520008,
    lng: 0.404954,
    country: 'Germany',
  },
  {
    lat: 36.148598,
    lng: 10.107748,
    country: 'Slovakia',
  },

  {
    lat: 44,
    lng: 13.753574,
    country: 'Lithuania',
  },
  {
    lat: 48,
    lng: 14.753574,
    country: 'Estonia',
  },
  {
    lat: 36.148598,
    lng: 5.107748,
    country: 'Czech Republic',
  },
]

export default capitals
